<template>
  <div class="disable-scroll-x">
    <div
      style="
        background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
      "
    >
      <CRow class="ml-5 mr-5 mb-5">
        <Mainlayout></Mainlayout>
        <br /><br /><br />
      </CRow>

      <CContainer>
        <div class="text-center d-sm-down-none">
          <h3 class="custom-64px text-white text-center">EdTournament</h3>
        </div>

        <!-- <div class="text-center d-md-none">
            <h3 class="custom-32px text-white text-center">Education Center</h3>
          </div> -->
      </CContainer>

      <CRow>
        <div class="card-custom-web" style="background: #fff">
          <CContainer>
            <div>
              <CRow>
                <CCol sm="6">
                  <div class="text-center m-0">
                  

                    <CCarousel
            arrows
            indicators
            animate
            loop
            height="400px"
            class="mt-5"
            interval="3000"
          >
            <CCarouselItem
              captionHeader="First Slide">
              <img src="../assets/img/step/1.png" style="max-width:100%"/>
              </CCarouselItem>
            <CCarouselItem
              captionHeader="Blank page"
              captionText="Nulla vitae elit libero, a pharetra augue mollis interdum."
            >
            <img src="../assets/img/step/2.png" style="max-width:100%"/></CCarouselItem>
            <CCarouselItem>
            <img src="../assets/img/step/3.png" style="max-width:100%"/>
          </CCarouselItem>
          <CCarouselItem>
            <img src="../assets/img/step/4.png" style="max-width:100%"/>
          </CCarouselItem>
          <CCarouselItem>
            <img src="../assets/img/step/5.png" style="max-width:100%"/>
          </CCarouselItem>
          <CCarouselItem>
            <img src="../assets/img/step/6.png" style="max-width:100%"/>
          </CCarouselItem>
          <CCarouselItem>
            <img src="../assets/img/step/7.png" style="max-width:100%"/>
          </CCarouselItem>
          <CCarouselItem>
            <img src="../assets/img/step/8.png" style="max-width:100%"/>
          </CCarouselItem>
          <CCarouselItem>
            <img src="../assets/img/step/9.png" style="max-width:100%"/>
          </CCarouselItem>
          <CCarouselItem>
            <img src="../assets/img/step/10.png" style="max-width:100%"/>
          </CCarouselItem>
          <CCarouselItem>
            <img src="../assets/img/step/11.png" style="max-width:100%"/>
          </CCarouselItem>
          </CCarousel>
          <br />
                <br />
               
                <br />


                  </div>
                  <CAlert color="info" class="mt-4">Tiada had jumlah pelajar dari sesebuah sekolah untuk mengambil bahagian dalam pusingan saringan</CAlert>
                </CCol>
                <CCol sm="6">
                  <CContainer class="text-left mt-4">
                    <CCard class="p-3">
                      <div v-if="this.ErrorPopup === true" class="">
                        <CAlert show color="danger"
                          >Error to Register.Please check form.
                        </CAlert>
                      </div>

                      <div
                          v-if="this.SuccessPopup === true"
                          class=""
                        >
                          <CAlert show color="success"
                            >Successfully to register EdTournament.Anda diminta juga join telegram channel dengan menekan button join di bawah ini untuk mendapatkan maklumat lanjut.
                            <div style="clear:both"></div>
                            <br />
                            <CButton
                            type="button"
                            class="btn custom-btn-login-forgot btn-info"
                            href="https://t.me/EdTournament"
                          >
                            OK
                          </CButton>
                          </CAlert>
                        </div>



<div v-if="detailForm === true">

                      <h1
                        class="
                          mt-3
                          mb-4
                          custom-24px
                          d-sm-down-none
                          text-left text-dark
                        "
                      >
                        <strong>Fill up the form following below</strong>
                      </h1>

                      <h1
                        class="mb-4 custom-24px d-md-none text-dark text-left"
                      >
                        <strong>Fill up the form following below</strong>
                      </h1>

                      <CRow>
                        <CCol sm="12">
                          Name
                          <br />
                          <CInput type="text" v-model="Name" />
                        </CCol>
                        <CCol sm="12">
                          Email
                          <br />
                          <CInput type="text" v-model="Email" />
                        </CCol>

                        <CCol sm="12">
                          Phone
                          <br />
                          <CInput type="text" v-model="Phone" />
                        </CCol>
                        <CCol sm="12">
                          Grade
                          <br />
                          <!-- <v-select
                            v-model="SelectedGrade"
                            :options="grades"
                            label="GradeName"
                            placeholder="--Please Select Grade--"
                            required
                          ></v-select> -->

                          <CInput type="text" v-model="Grade" placeholder="eg. Form 1"/>
                        </CCol>
                        <CCol sm="12">
                          School Name
                          <br />
                          <CInput type="text" v-model="SchoolName" placeholder="eg. Sekolah Menengah Cheras" />
                        </CCol>

                        <br />
                        <br />
                        <CButton
                          type="button"
                          color="primary"
                          class="btn custom-btn-login-forgot btn-info ml-3 mt-2"
                          @click="SubmitPromo"
                          block
                          >Register</CButton
                        >
                        <br />
                        <label class="ml-2 mr-2">Anda dikehendaki mendaftar terlebih dahulu dan diikuti dengan bergabung dalam channel EdTournament dengan menekan butang Join Channel di bawah</label>
                        <CButton
                          type="button"
                          color="success"
                          class="btn custom-btn-login-forgot btn-info ml-3 mt-2"
                          href="https://t.me/EdTournament"
                          block
                          >Join Channnel</CButton
                        >
                        <br />
                        <!-- </CCol> -->
                      </CRow>
                      </div>

                      
                    </CCard>
                  </CContainer>
                </CCol>
              </CRow>
            </div>
          </CContainer>
        </div>
      </CRow>
      <div>
        <div style="background: #1899ed">
          <CContainer>
            <CRow>
              <CCol sm="4">
                <br />
                <br />
                <br />
                <div class="p-2">
                  <img style="max-width:100%" src="../assets/img/billion.png" />
                </div>
                <br />
                <!-- <img style="max-width:100%" src="../assets/img/pertandingan.png" /> -->
              </CCol>
              <CCol sm="4">
                <div class="p-2">
                  <img style="max-width:100%" src="../assets/img/pertandingan2.png" />
                </div>
              </CCol>
              <CCol sm="4">
                <div class="text-center">
                  <br />
                  <h5
                      style="color: #fff"
                      class="d-sm-down-none text-left text-center"
                    >
                      <strong>Register EdTournament</strong>
                    </h5>

                    <h1
                      style="color: #fff"
                      class="ml-5 mt-5 custom-24px d-md-none text-center"
                    >
                      <strong>Register EdTournament</strong>
                    </h1>

                    <label class="d-sm-down-none text-center text-white"
                      >Watch any video online class <br />from more 30 session</label
                    >
                    <label class="d-md-none text-center text-white"
                      >Watch any video online class from more 30 session</label
                    >
                    <br />
                    <div class="text-center">
                    <img style="max-width:100%;max-height:200px" src="../assets/img/pertandingan.png" />
                  </div>
                </div>
              </CCol>
            </CRow>
          </CContainer>
        </div>
      </div>
    
    </div>

    <Footerlayout></Footerlayout>
  </div>
</template>
        
        
        
        
        <script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import AnimatedNumber from "animated-number-vue";
import backgroundBanner from "../assets/img/promodesign.png";

// import Translator from "vue-gtranslate";
// import "vue-gtranslate/translator.css";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";

import VueAgile from "vue-agile";
Vue.use(VueAgile);

import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import _ from "lodash";
new Vue({
  el: "#navbar",

  data() {
    return {
      view: {
        topOfPage: true,
      },
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.pageYOffset > 400) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
          el.setAttribute(
            "style",
            "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
          );
        }
      } else {
        if (!this.view.topOfPage) this.view.topOfPage = true;
        el.setAttribute(
          "style",
          "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
        );
      }
    },
  },
});
export default {
  name: "Login",
  components: {
    Mainlayout,
    Footerlayout,
  },
  data() {
    return {
      Name: "",
      Email: "",
      Phone: "",
      Code: "",
      Grade: "",
      SchoolName: "",
      SuccessPopup: false,
      ErrorPopup: false,

      SelectedGrade: "",
      grades: [],
      detailForm: true,
      loop: "",
    };
  },
  created() {
    AOS.init();
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);

     if (window.location.hostname !== 'www.pickiddo.com/edtournament') {
        window.location.href = 'https://www.pickiddo.com/edtournament'
    }
  },
  async mounted() {
    this.GetGrade();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {},

  methods: {
    getBadge(status) {
      switch (status) {
        case "Active":
          return "success";
        case "Inactive":
          return "secondary";
        case "Pending":
          return "warning";
        case "Banned":
          return "danger";
        default:
          "primary";
      }
    },
    onScroll() {
      // Get the current scroll position
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return;
      }
      // Here we determine whether we need to show or hide the navbar
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition;
    },
    handleScroll() {
      if (window.pageYOffset > 1000) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
        } else {
          this.view.topOfPage = true;
        }
      }
    },
    GetGrade() {
      this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
    },
    async SubmitPromo() {
      if (
        this.Name == "" ||
        this.Email == "" ||
        this.Phone == "" ||
        this.Grade == "" ||
        this.SchoolName == ""
      ) {
        this.ErrorPopup = true;
      } else {
        this.Busy = true;
        this.detailForm = false;
        const formData = new FormData();

        formData.append("Email", this.Email);
        formData.append("Name", this.Name);
        formData.append("Phone", this.Phone);
        formData.append("Grade", this.Grade);
        formData.append("SchoolName", this.SchoolName);

        return this.$API
          .post(this.$InsertRegisterEdTournament, formData, {})
          .then((response) => {
            if (response.status == 200) {
              this.SuccessPopup = true;
            } else {
              this.Busy = false;
              this.$dialog
                .alert("Error to create packagess")
                .then(function () {});
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      }
    },
    GoToApp() {
      this.detailForm = false;
      this.$router.push("DownloadApp");
    },
  },
};
</script>
            <<style scoped>
        
        @import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
        @import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
            
        .c-header {
          /* background: rgb(23, 77, 124);
          background: linear-gradient(92deg, #174d7c, #1b7682);
          border-bottom: 0.01px solid #1a6783;
          border-bottom: 1px solid #636f83; */
        
          background: transparent;
          border-bottom: 0;
          border-bottom: 0;
          /* color: #fff; */
        }
        .c-app{
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
          font-family: 'Montserrat', sans-serif;
        }
        body {
          font-family: "Montserrat", sans-serif;
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        }
        h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
            margin-bottom: 0.5rem;
            font-weight: 500;
            line-height: 1.2;
            font-family: "Montserrat", sans-serif;
        }
        label
        {
          font-family: "Montserrat", sans-serif;
        }
        
        body nav.onScroll {
          box-shadow: 0 0 10px #aaa;
          background-color: rgb(255, 255, 255);
          font-family: 'Montserrat';
        font-style: normal;
        }
        body nav.onScroll ul li {
          color: #10b761;
        }
        body nav ul {
          margin-left: 3em;
          width: 25%;
          display: flex;
          justify-content: space-between;
        }
        body nav ul li {
          cursor: pointer;
          font-weight: 600;
          list-style-type: none;
          color: white;
        }
        body {
            top: 0 !important;
            font-family: 'Montserrat', sans-serif;
        }
      
        
      input {
        border-bottom: 2px solid #fff;
        background: none;
        border-top: none;
        border-left: none;
        border-right: none;
        width: -webkit-fill-available;
         -webkit-text-fill-color: white !important;
      
      }
      input ::placeholder {
        color: #e0e0e0;
      }
      
      ::placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #e0e0e0;
      }
      .custom-user-input {
        /* Body/1/Semibold */
      
        display: flex;
        justify-content: center;
        flex-flow: row nowrap;
      }
    
    
    .js-click:active{
      background:#E8F4FF;
      border-radius:20px;
      border:1px solid #E8F4FF;
    }
    
    .js-click:focus{
      background:#E8F4FF;
      border-radius:20px;
      border:1px solid #E8F4FF;
    }
    
         </style>